




import { computed, defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "Divider",
  props: {
    height: { type: [String, Number], default: "8px" },
    borderTop: { type: Boolean, default: false },
  },
  setup(props) {
    const dividerHeight = computed(() => {
      if (typeof props.height === "string") return props.height;
      return `${props.height}px`;
    });
    return {
      dividerHeight,
    };
  },
});
